























































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {AxiosResponse} from 'axios';
import AdvancedConfirmDialog, {
  ConfirmationDialogButton,
  ConfirmationDialogConfig
} from '@/views/AdvancedConfirmDialog.vue';
import {URL_SERVICE_INSTANCE} from '@/services/url.service';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';

@Component({
  components: {AdvancedConfirmDialog, AmetrasTextFieldTemplate, AmetrasSelectFieldTemplate, AmetrasCheckBoxTemplate}
})
export default class DataTableCustomFilter extends Vue {

  @Prop({
    type: Object as () => DisguiseDto.DTCustomFilterConfigurationSettingsDto,
    required: false,
    default: () => {
      return {};
    }
  }) customFilterConfig!: DisguiseDto.DTCustomFilterConfigurationSettingsDto;
  @Prop({
    type: Object as () => DisguiseDto.DTInputConfigurationDto,
    required: false,
    default: () => {
      return {};
    }
  }) inputConfiguration!: DisguiseDto.DTInputConfigurationDto;

  confirmationDialogConfig: ConfirmationDialogConfig | null = null;
  displayCustomFilterDialog: boolean = false;
  customFilterSaveRunning: boolean = false;
  currentFilterConfig: DisguiseDto.FilterConfigurationSelectionDto = {};
  possibleSelectableFilters: DisguiseDto.SelectDto[] = [];
  possibleEditableFilters: DisguiseDto.SelectDto[] = [];

  @Watch('customFilterConfig', {}) onFilterConfigChanged(
      newFilterConfig: DisguiseDto.DTCustomFilterConfigurationSettingsDto,
      oldFilterConfig: DisguiseDto.DTCustomFilterConfigurationSettingsDto
  ) {
    if (newFilterConfig !== oldFilterConfig) {
      this.definePossibleSelectableFilters(newFilterConfig);
    }
  }

  created() {
    this.definePossibleSelectableFilters(this.customFilterConfig);
  }

  selectFilterConfigByValueAndPublish(filterValueOfFilterToBeSelected: string) {
    let newFilter: DisguiseDto.FilterConfigurationSelectionDto | undefined;
    for (const currentFilterConfig of (this.customFilterConfig || {}).possibleConfigurations || []) {
      if (currentFilterConfig.value === filterValueOfFilterToBeSelected) {
        newFilter = currentFilterConfig;
        break;
      }
    }

    if (newFilter !== undefined) {
      this.selectFilterConfig(newFilter);
    }
  }

  selectFilterConfigByValue(filterValueOfFilterToBeSelected: string) {
    let newFilter: DisguiseDto.FilterConfigurationSelectionDto | undefined;
    for (const currentFilterConfig of (this.customFilterConfig || {}).possibleConfigurations || []) {
      if (currentFilterConfig.value === filterValueOfFilterToBeSelected) {
        newFilter = currentFilterConfig;
        break;
      }
    }

    if (newFilter !== undefined) {
      this.currentFilterConfig = newFilter;
    } else {
      this.currentFilterConfig = {};
    }
  }

  closeCustomFilterDialog() {
    this.displayCustomFilterDialog = false;
    this.currentFilterConfig = {};
  }

  saveCustomFilter() {
    this.customFilterSaveRunning = true;
    HTTP_SERVICE_INSTANCE.getAxios().post<DisguiseDto.FilterConfigurationSelectionDto>(
        this.customFilterConfig?.configurationEndpointUrl || '', {
          filterName: this.currentFilterConfig.text,
          existingFilterValue: this.currentFilterConfig.value,
          isDefault: this.currentFilterConfig.isDefault,
          searchValue: this.inputConfiguration.searchValue !== '' ? this.inputConfiguration.searchValue : undefined,
          columns: ((inputConfigurationColumns: DisguiseDto.DTInputColumnDto[]) => {
            const result: DisguiseDto.DTFilterSaveColumnDto[] = [];

            for (const currentInputConfigurationColumn of inputConfigurationColumns) {
              const hasAnyColumnModification = currentInputConfigurationColumn.searchValue !== ''
                  || (currentInputConfigurationColumn.searchValues || []).length > 0
                  || currentInputConfigurationColumn.sort !== undefined;
              if (hasAnyColumnModification) {
                result.push({
                  key: currentInputConfigurationColumn.key,
                  searchValue: currentInputConfigurationColumn.searchValue !== '' ? currentInputConfigurationColumn.searchValue : undefined,
                  searchValues: (currentInputConfigurationColumn.searchValues || []).length > 0 ? currentInputConfigurationColumn.searchValues : undefined,
                  sort: currentInputConfigurationColumn.sort !== undefined ? currentInputConfigurationColumn.sort : undefined,
                  sortRank: currentInputConfigurationColumn.sortRank !== undefined ? currentInputConfigurationColumn.sortRank : undefined,
                });
              }
            }

            return result;
          })(this.inputConfiguration.columns || [])
        } as DisguiseDto.DTFilterSaveDto).then(
        (response: AxiosResponse<DisguiseDto.FilterConfigurationSelectionDto>) => {
          this.$store.commit('showSnack', {
            message: (this.customFilterConfig || {}).customizeFilterSaveSuccessMessage,
            color: 'success'
          });

          this.closeCustomFilterDialog();
          this.customFilterSaveRunning = false;
          this.selectFilterConfig(response.data);
        }
    ).catch(() => {
      this.$store.commit('showSnack', {
        message: (this.customFilterConfig || {}).customizeFilterSaveFailMessage,
        color: 'error'
      });
      this.customFilterSaveRunning = false;
    });
  }

  selectFilterConfig(newFilter: DisguiseDto.FilterConfigurationSelectionDto) {
    this.$emit('change', newFilter);
  }

  deleteFilter() {
    this.confirmationDialogConfig = {
      title: (this.customFilterConfig || {}).customizeFilterDeleteConfirmationDialogTitle,
      headerColor: 'primary',
      message: (this.customFilterConfig || {}).customizeFilterDeleteConfirmationDialogMessage || '',
      buttons: [{
        text: (this.customFilterConfig || {}).customizeFilterDeleteConfirmationDialogConfirmButtonText || '',
        title: (this.customFilterConfig || {}).customizeFilterDeleteConfirmationDialogConfirmButtonTooltip || '',
        disabled: false,
        loading: false,
        autoFocus: true,
        onClick: (button: ConfirmationDialogButton) => {
          button.loading = true;
          button.disabled = true;
          const configurationEndpointUrl = this.customFilterConfig?.configurationEndpointUrl || '';
          const configurationEndpointUrlWithParams = configurationEndpointUrl + (configurationEndpointUrl.indexOf('?') > 0 ? '&' : '?') + URL_SERVICE_INSTANCE.serialize( {
            existingFilterValue: this.currentFilterConfig.value
          } as DisguiseDto.DTFilterSaveDto);
          HTTP_SERVICE_INSTANCE.getAxios().delete(configurationEndpointUrlWithParams).then(() => {
            this.$store.commit('showSnack', {
              message: (this.customFilterConfig || {}).customizeFilterDeleteSuccessMessage,
              color: 'success'
            });
            this.closeCustomFilterDialog();
            this.$emit('change', undefined);
            this.confirmationDialogConfig = null;
          }, (error) => {
            if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
              this.$store.commit('showSnack', {
                message: (this.customFilterConfig || {}).customizeFilterDeleteFailMessage,
                color: 'error'
              });
            }
            button.loading = false;
            button.disabled = false;
          });
        }
      }, {
        text: (this.customFilterConfig || {}).customizeFilterDeleteConfirmationDialogAbortButtonText || '',
        title: (this.customFilterConfig || {}).customizeFilterDeleteConfirmationDialogAbortButtonTooltip || '',
        disabled: false,
        loading: false,
        onClick: () => {
          this.confirmationDialogConfig = null;
        }
      }],
      onEsc: () => {
        this.confirmationDialogConfig = null;
      }
    };
  }

  editFilterConfig() {
    this.displayCustomFilterDialog = true;
  }

  private definePossibleSelectableFilters(filterConfig: DisguiseDto.DTCustomFilterConfigurationSettingsDto) {
    const newPossibleSelectableFilters: DisguiseDto.SelectDto[] = [];
    const newPossibleEditableFilters: DisguiseDto.SelectDto[] = [];
    for (const currentConfiguration of (filterConfig || {}).possibleConfigurations || []) {
      const newFilter = {
        text: `${currentConfiguration.text}${currentConfiguration.isDefault && currentConfiguration.isEditable ? filterConfig.defaultAppendix || '' : ''}`,
        value: currentConfiguration.value
      };
      newPossibleSelectableFilters.push(newFilter);
      if (currentConfiguration.isEditable) {
        newPossibleEditableFilters.push(newFilter);
      }
    }
    this.possibleSelectableFilters = newPossibleSelectableFilters;
    this.possibleEditableFilters = newPossibleEditableFilters;
  }

}
